import HttpClient from '@/services/HttpClient';
import { packageOfferSelection } from '@/modules/agreements/packageOfferSelection';

// An agreement template's public link (/docs/:slug). The agreement is built from the template on
// each load and only saved when the visitor submits, so every call is by workspace + slug.
export default class PublicAgreementViewerService {
	constructor(podUrl, accountId, slug) {
		this.accountId = accountId;
		this.slug = slug;
		this.httpClient = new HttpClient(podUrl, false);
	}

	getAgreement() {
		return this.httpClient.get('/api/docs/public-agreement', { params: { accountId: this.accountId, slug: this.slug } });
	}

	quotePackageOffer(selection) {
		return this.httpClient.post('/api/docs/public-agreement/package-offer/quote', packageOfferSelection(selection), {
			params: { accountId: this.accountId, slug: this.slug },
		});
	}

	// Resolves to { outcome: 'SIGNED', token } or { outcome: 'REQUIRES_ACTION', paymentIntentId, clientSecret }
	submit(agreement, { packageOffer = null, templateVersion, submissionKey, paymentMethodId = null, paymentIntentId = null, amount = null }) {
		const formData = new FormData();
		const files = agreement.fileUploads || [];
		const body = { ...agreement };
		delete body.fileUploads;
		formData.append('accountId', this.accountId);
		formData.append('slug', this.slug);
		formData.append(
			'submission',
			JSON.stringify({ agreement: body, packageOffer, templateVersion, submissionKey, paymentMethodId, paymentIntentId, amount })
		);
		files.forEach((file) => formData.append('files', file));
		return this.httpClient.post('/api/docs/public-agreement', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
	}
}
